import React, { useCallback, useEffect, useState } from 'react';
import axios from "axios";
import { setCookie } from 'nookies'
import nookies from 'nookies';
import { destroyCookie } from 'nookies'

let logoutTimer;
const priceID = [
    {
        id: 201,
        planDay: '1 Day Plan',
        priceTerm: '($29.99/daily)',
        priceID: [
            {
                id: '2001',
                priceId: 'price_1LG4n1AMkQceT942jcz6HVn5',
            }
        ]
    }, {
        id: 202,
        planDay: '3 Day Plan',
        priceTerm: '($74.99/3 days)',
        priceID: [
            {
                id: '2002',
                priceId: 'price_1KQnJ2AMkQceT942IHQeQ2Mn',
            }
        ]
    }, {
        id: 203,
        planDay: '1 Week Plan',
        priceTerm: '($124.99/weekly)',
        priceID: [
            {
                id: '2003',
                priceId: 'price_1LG4o0AMkQceT942tUWMjrq2',
            }
        ]
    }, {
        id: 204,
        planDay: '1 Month Plan',
        priceTerm: '($294.99/monthly)',
        priceID: [
            {
                id: '2004',
                priceId: 'price_1KQnJOAMkQceT9427cgcAWRw',
            }
        ]
    }, {
        id: 205,
        planDay: '1 Year',
        priceTerm: '($1,294.99/yearly)',
        priceID: [
            {
                id: '2005',
                priceId: 'price_1KQnKDAMkQceT942hI2jExRV',
            }
        ]
    },

]
const AuthContext = React.createContext({
    token: '',
    isLoggedIn: false,
    login: (token) => {
    },
    logout: () => {
    },
    isActive: false,
    timePeriod: '',
    email: ''
})
export const AuthContextProvider = (props) => {

    let jwtToken;
    let [roleStatus, setRoleStatus] = useState(false);
    const [priceId, setPriceID] = useState(priceID);

    let [time__period, setTime] = useState('');
    const retrieveStoredToken = () => {
        return {
            token: jwtToken
        };
    };
    const tokenData = retrieveStoredToken();

    let initialToken;
    if (tokenData) {
        initialToken = tokenData.token;
    }

    const [token, setToken] = useState(initialToken);
    const [mail, setMail] = useState('');

    let userIsLoggedIn = !!token;

    const logoutHandler = useCallback((ctx) => {
        destroyCookie({ ctx }, 'jwt', {
            path: '/',
        });
        setToken(null);
        userIsLoggedIn = false;
        if (logoutTimer) {
            clearTimeout(logoutTimer);
        }
    }, []);

    const initialize = async (ctx) => {
        const cookies = nookies.get(ctx)
        if (cookies?.jwt) {
            try {
                const { data } = await axios.get("https://admin.capncovers.com/api/users/me", {

                    // const { data } = await axios.get("http://localhost:1337/api/users/me",{
                    headers: {
                        Authorization:
                            `Bearer ${cookies?.jwt}`
                    },
                });
                // console.log(data);
                // console.log(cookies?.jwt);
                setRoleStatus(data.isActive);
                userIsLoggedIn = true;
                setMail(data.email);
            } catch (e) {
                console.log(e.response.data.error.message)
            }

        }


    }

    const login = async (body) => {
        const res = await axios.post("https://admin.capncovers.com/api/auth/local", body);
        // const res = await axios.post("http://localhost:1337/api/auth/local", body);
        let token = res.data.jwt
        setToken(token);
        setCookie({ res }, 'jwt', token, {
            path: '/',
        });
        if (res.status === 200) {
            return res
        }
        return null;
    }

    // TODO - also creaate register function here
    const register = async (body) => {
        const data = await axios.post("https://admin.capncovers.com/api/auth/local/register", body);
        // const data =await axios.post("http://localhost:1337/api/auth/local/register", body);
        let token = data.data.jwt
        setToken(token);
        setCookie({ data }, 'jwt', data.data.jwt, {
            path: '/',
        });
        return data
    }


    useEffect(() => {
        initialize();

    }, []);

    useEffect(() => {
        if (tokenData) {
            logoutTimer = setTimeout(logoutHandler, 1000 * 60 * 60);
        }
    }, [tokenData, logoutHandler]);

    const contextValue = {
        setToken,
        isLoggedIn: userIsLoggedIn,
        login,
        logout: logoutHandler,
        setRoleStatus,
        register,
        setTime,
        isActive: roleStatus,
        timePeriod: time__period,
        setMail,
        mail,
        priceId,
        setPriceID,
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {props.children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
